import React, { Component } from 'react';
import Navbar from 'components/nav/merchant/nav';

class MerchantLayout extends Component {
  render() {
    return (
      <div className="container-fluid">
        <div className="row">
          <Navbar />
        </div>
        {this.props.children}
      </div>
    );
  }
}
export default MerchantLayout;